import { makeStyles } from '@material-ui/core/styles';

import { CANCELLATION_TONE_COLORS } from '../Pill/pill.styles';

export const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        borderRadius: 8,
        padding: '12px 16px',
        marginBottom: 8,
    },
    icon: {
        flexShrink: 0,
    },
    text: {
        fontSize: 14,
        '& strong': {
            fontWeight: 600,
        },
    },
    // Derived from theme.palette.info.main (#00d7ff): a 10% white/info tint for
    // the background, and info.main darkened 25% for text/icon — the darker
    // shade is required for WCAG AA contrast (info.main itself is too light).
    change: {
        backgroundColor: '#E6FBFF',
        color: '#006B80',
    },
    // Shares Pill's cancellationPending tone for consistency with the
    // "CANCELLATION PENDING" badge shown alongside this.
    cancellation: {
        ...CANCELLATION_TONE_COLORS,
    },
}));
